module.exports = __webpack_public_path__ + "img/step3.43d7e1e9.png";